import { render, staticRenderFns } from "./SmartPlusMaterialReport.vue?vue&type=template&id=54631f44&scoped=true&"
import script from "./SmartPlusMaterialReport.vue?vue&type=script&lang=js&"
export * from "./SmartPlusMaterialReport.vue?vue&type=script&lang=js&"
import style0 from "./SmartPlusMaterialReport.vue?vue&type=style&index=0&id=54631f44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54631f44",
  null
  
)

export default component.exports